import { useAuthStore } from '@/features/auth/auth-store';
import { useReferralsStore } from '@/features/referrals/referrals-store';

/**
 * "Your referral performance" (SCRUM-388) — the v7 Teller-only dashboard card:
 * Submitted / Converted / Success rate over the teller's OWN submissions
 * (matched by referrer display name, the store's submitter identity).
 */
export function TellerPerformanceCard() {
  const user = useAuthStore((s) => s.user);
  const referrals = useReferralsStore((s) => s.referrals);

  const mine = referrals.filter((r) => r.tellerName === (user?.displayName ?? ''));
  const converted = mine.filter((r) => r.converted).length;
  const rate = mine.length ? Math.round((converted / mine.length) * 100) : 0;

  return (
    <section
      aria-label="Your referral performance"
      className="bg-bg-4 border-border-0 rounded-tk-lg border p-4"
    >
      <span className="font-display text-text-0 text-base font-semibold">
        Your referral performance
      </span>
      <div className="mt-3 grid grid-cols-3 gap-3">
        <Stat value={String(mine.length)} label="Submitted" />
        <Stat value={String(converted)} label="Converted" />
        <Stat value={`${String(rate)}%`} label="Success rate" />
      </div>
    </section>
  );
}

function Stat({ value, label }: { value: string; label: string }) {
  return (
    <div className="bg-bg-2 rounded-tk-md px-4 py-3 text-center">
      <div className="font-display text-text-0 text-xl font-semibold">{value}</div>
      <div className="text-text-3 mt-0.5 text-xs">{label}</div>
    </div>
  );
}
